import { render, staticRenderFns } from "./RecurringPaymentReview.vue?vue&type=template&id=2042440e&scoped=true&"
import script from "./RecurringPaymentReview.vue?vue&type=script&lang=js&"
export * from "./RecurringPaymentReview.vue?vue&type=script&lang=js&"
import style0 from "./RecurringPaymentReview.vue?vue&type=style&index=0&id=2042440e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2042440e",
  null
  
)

export default component.exports